module.exports = __webpack_public_path__ + "img/liveTimeDownloadBg.a9e98e0f.png";